<template>
  <div>
    <template v-if="onProcess">
      <loader :content="'Please wait'" :visible="onProcess" />
    </template>
    <template v-else>
      <div class="container" style="padding-top: 75px;">
        <div class="row text-center">
          <template v-if="!paymentSuccess">
            <div class="image-failed"></div>
            <div class="col-md-8 col-md-offset-2 text-center">
              <h3>Oops! payment failed</h3>
              <p class="text-center mb-20">
                You can retry or change your payment method easily on the
                reservation page.
              </p>
              <div class="button-group">
                <router-link
                  :to="`/reservation/inquiry/${reservationId}`"
                  class="btn btn-primary"
                >
                  Go to reservation
                </router-link>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import paymentService from "@/services/shop/paymentService.js";

export default {
  data() {
    return {
      channel: null,
      reservationId: null,
      amendmentId: null,
      companyId: null,
      tenantId: null,
      returnUrl: null,
      username: null,
      token: null,
      onProcess: true,
      paymentSuccess: false
    };
  },
  async created() {
    this.channel = this.$route.query.channel;
    this.reservationId = this.$route.query.reservation_id;
    this.amendmentId = this.$route.query.amendment_id;
    this.companyId = this.$route.query.company_id;
    this.tenantId = this.$route.query.tenant_id;
    this.returnUrl = this.$route.query.return_url
      ? decodeURI(this.$route.query.return_url)
      : null;
    this.username = this.$route.query.username;
    this.token = this.$route.query.token;

    if (this.channel && this.reservationId) {
      if (this.channel.toLowerCase() === "reddotpayment") {
        this.payUsingRDP();
      }

      if (this.channel.toLowerCase() === "paypal") {
        await this.payUsingPaypal();
      }

      if (this.channel.toLowerCase() === 'airwallex') {
        await this.payUsingAirwallex();
      }
    } else {
      this.throwNotFound();
    }
  },
  methods: {
    async payUsingPaypal() {
      try {
        const param = `ReservationId=${this.reservationId}&AmendmentId=${this.amendmentId}&Channel=${this.channel}&OrderId=null&TransactionId=null&Token=
${this.token}`;
        const response = await paymentService.amendPayCredit(param);

        if (response.isSuccess) {
          this.paymentSuccess = response.isSuccess;
          if (this.returnUrl) {
            window.open(this.returnUrl, "_self");
          }
        }
      } catch (error) {
        this.onProcess = false;
        if (error.errors.length) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    async payUsingAirwallex() {
      try {
        const param = `reservationId=${this.reservationId}&amendmentId=${this.amendmentId}&channel=${this.channel}&orderId=${this.$route.query.id}`;
        const response = await paymentService.amendPayCredit(param);

        if (response.isSuccess) {
          this.paymentSuccess = response.isSuccess;
          if (this.returnUrl) {
            window.open(this.returnUrl, "_self");
          }
        }
      } catch (error) {
        this.onProcess = false;
        if (error.errors.length) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
      // const paymentIntentId = this.$route.query.id;

      // if (token) {
      //   const extraParams = `&orderId=${paymentIntentId}`;
      //   await this.callPayCheckerApi(extraParams);
      // } else {
      //   this.throwNotFound();
      // }
    },
    payUsingRDP() {
      // console.log('on development')
    },
    throwNotFound() {
      this.$router.push({ path: "/404" });
    }
  }
};
</script>

<style scoped>
.underline-loader {
  color: #4fb848;
  font-weight: bold;
  font-size: 30px;
  padding: 0 5px 15px 0;
  background: repeating-linear-gradient(90deg, currentColor 0 8%, #0000 0 10%)
    200% 100%/200% 3px no-repeat;
  animation: c3 2s steps(6) infinite;
}
@keyframes c3 {
  to {
    background-position: 80% 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payment/credit/AmendRedirect.vue